import{pipe as e}from"./pipe-BWjVFU-o.js";function t(...t){return n=>e(n,...t)}export{t as piped};
//# sourceMappingURL=piped-C7rf-q76.js.map